/**
 * Vanilla Swiper initialization for the Slider Elementor widget — LIVE
 * FRONTEND ONLY. Delegates the actual options-building/construction to
 * the shared dist/js/elementor-swiper-carousel.js (also used by the
 * Products widget) — this file now only owns the Slider-specific hook
 * name and DOM scoping.
 *
 * Data-attribute prefix (`data-gws-carousel-*`, read by the shared
 * script) and internal DOM class names (`.gws-hero*`, still "hero"
 * despite the widget's public rename to "Slider") are documented in the
 * widget PHP class's own docblock — `.gws-hero*` exists only to reuse the
 * original Gutenberg hero block's compiled CSS, unrelated to either the
 * widget's public identity or the (now-shared) carousel data-attribute
 * naming.
 *
 * Editor-preview behavior (including "Editing Mode") lives entirely in
 * the separate dist/js/elementor-slider-editor-mode.js instead of here —
 * deliberately isolated so a bug in editor-only logic can never reach
 * real visitors. This file's own isEditMode() branch below is only a
 * defensive no-op (in case that file fails to load for some reason), not
 * where editor behavior is implemented.
 */
( function () {
	'use strict';

	function registerElementReadyHook() {
		window.elementorFrontend.hooks.addAction( 'frontend/element_ready/gws-slider.default', function ( $scope ) {
			var hero = $scope[ 0 ].querySelector( '.gws-hero--carousel' );

			if ( ! hero ) {
				return;
			}

			// Editor preview is handled entirely by
			// elementor-slider-editor-mode.js instead — defensive no-op only.
			if ( window.elementorFrontend.isEditMode && window.elementorFrontend.isEditMode() ) {
				return;
			}

			var carousel = hero.querySelector( '.swiper' );

			if ( carousel ) {
				window.GWSInitSwiperCarousel( carousel );
			}

			// Directly re-sweeps for any Manual Card/Category Card widget
			// (.gws-card) nested inside a slide, rather than relying on
			// THEIR OWN frontend/element_ready hook to have already sized
			// every instance. Necessary specifically for loop-mode PADDING
			// (get_carousel_render_data()'s min_loop_slides, trait-gws-
			// elementor-swiper-carousel.php): render_carousel_slides()
			// pads a too-short slide list by calling print_child() again
			// on an EXISTING child index, printing the SAME nested
			// Elementor element's markup (same data-id) a second time.
			// Confirmed live: those duplicated copies' own card-sizer
			// never ran, breaking their height - consistent with Elementor's
			// own per-element-ID frontend init dispatch not re-firing
			// frontend/element_ready for what it considers an
			// already-initialized element ID, even though a second,
			// separate DOM node now exists for it. GWSInitCardSizer() has
			// no "already initialized" guard of its own and operates on
			// whatever exact DOM node it's given (a fresh ResizeObserver
			// per call) - safe to call redundantly on an instance that
			// WAS already sized via its own hook, and correctly sizes an
			// instance that wasn't.
			if ( window.GWSInitCardSizer ) {
				hero.querySelectorAll( '.gws-card' ).forEach( function ( card ) {
					window.GWSInitCardSizer( card );
				} );
			}
		} );
	}

	if ( window.elementorFrontend && window.elementorFrontend.hooks ) {
		registerElementReadyHook();
	} else {
		window.addEventListener( 'elementor/frontend/init', registerElementReadyHook );
	}
} )();
